import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isInternalOperatorSessionActive } from '../services/internalSession';

interface InternalSessionGuardProps {
  children: React.ReactNode;
}

export const InternalSessionGuard: React.FC<InternalSessionGuardProps> = ({ children }) => {
  const { isAuthenticated, authRole, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <div className="w-8 h-8 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/internal/login" replace />;
  }

  if (authRole !== 'super_admin') {
    return <Navigate to="/login" replace />;
  }

  if (!isInternalOperatorSessionActive()) {
    return <Navigate to="/internal/login" replace />;
  }

  return <>{children}</>;
};
